import React from "react"
import { Input } from "./Input"

export const MobileNumberInput = ({
  value,
  onChange,
  placeholder,
  disabled,
}) => {
  const handleChange = e => {
    const inputValue = e.target.value.replace(/\D/g, "")
    if (inputValue.length <= 10) {
      onChange(inputValue)
    }
  }

  return (
    <div className="mobile-input-container">
      <Input
        type="tel"
        value={value}
        onChange={handleChange}
        placeholder={placeholder || "Enter WhatsApp Number Here"}
        disabled={disabled}
        className="mobile-input"
        aria-label="Mobile number"
        maxLength={10}
        inputMode="numeric"
      />
    </div>
  )
}
